export default function Description() {
  return (
    <div className="description">
      <div>
        <h1>Hello!</h1>
        <p>
          Here are the descriptive details for this weekend, in increasing order
          of descriptiveness
        </p>
      </div>
      <div>
        <h2>Timing</h2>
        <p>
          Saturday May 22nd starting @ 2pm, but I expect people to trickle in
          and out. The invite list is fairly small, so you should be fine to
          invite a friend or two if you are inspired-- I figure we can all feel
          it out. I expect friendly old people from my neighborhood to be
          popping by, so just give them a hearty hello and point them toward
          pizza and/or drink and/or see what's up with them
        </p>
      </div>
      <div>
        <h2>Substances</h2>
        <ul>
          <li>Pizza</li>
          <li>Bring toppings if you would like a custom za</li>
          <li>Beverages</li>
          <li>
            I will provide a general array of the alcoholic and non, but I
            encourage you to bring your own to share as well
          </li>
          <li>Snacks</li>
          <li>
            I’m going to wing this, but also encourage you to bring anything you
            would like to share. I suppose this is an optional potluck of sorts
          </li>
          <li>Dogs</li>
          <li>
            I have two derpy black labs, one is very old and may accidentally
            run into you, but I assure you it’s a sign of affection. The other
            one will welcome you by making strange moaning noises, this is more
            obviously a sign of affection. You are also encouraged to bring your
            own dog to share for everyone’s benefit
          </li>
          <li>Other stuff...</li>
          <li>
            Some other vaguely legal things that feel like they require a little
            discretion, but I’m mentioning this to convey that this is a safe
            place to thoughtfully partake in whatever you enjoy!{" "}
          </li>
        </ul>
      </div>
      <div>
        <h2>Enviornment</h2>
        <p>
          I have a nicely sized front yard, it’s not enormous, but it has plenty
          of space surrounding the house and is completely walled-- so your
          furry friends are safe to wander! Feel free to collect some fruit as
          well, though I think only the lemons and loquats are truly in season
          at the moment-- but you’ll find a pomelo or two as well. You’re
          welcome to venture inside whenever you need it, but hopefully the
          weather will allow us to mostly hang outside into the eve under some
          lovely illuminations
        </p>
        <p>
          There will be some blankets to sit/lie on, various chairs to chill in,
          a table or two for whatever items. If you can, bring a cozy item or
          two to add to the loungefest. There is a spot down the street where I
          like to catch the sunset, we can easily stumble down there to properly
          welcome the night. Once it’s dark enough we can fire up some lights.
          I’ll try to throw together a fun little camera + projector experience
          for some movement play, and perhaps at some point we will just sit
          back and watch a movie or something if the vibe is right
        </p>
        <p>
          I will have my PA setup for a proper A/V experience for the entirety
          of the day/eve. I created a simple mostly functional jukebox app so we
          can all DJ seamlessly. If there is a consensus to do one thing or the
          other with the music, we can cross the bridge when we are in that
          mindset
        </p>
      </div>
      <div>
        <h2>Why</h2>
        <p>
          If you were invited to this gathering, you are either someone I
          admire, or you are the friend of someone I admire, and so I am one
          pizza away from admiring you. This is all about meeting some new
          faces, reconnecting with old ones, sharing some fun things, and
          building a safe place together among trees. Where it goes from here is
          as uncertain as anything else, but if you are so inspired, let's all
          chat about what we can do next 💃
        </p>
      </div>
    </div>
  );
}
